import { getAllLayers } from 'pxc-editor-core/helpers/schema';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { USER_SIZE_UNIT_INCH, APP_ENVIRONMENT, MARKING_EDITOR_WEB_COMPONENT_ELEMENT, XCORE_ENVIRONMENT } from '@/constants';
import { inchToMm, mmToInch } from './common';

export const getFirstSelectedSection = (sectionsSelection, pages) => {
  for (const secId in sectionsSelection) {
    const { section } = getAllLayers(secId, pages);
    return section;
  }
};

export const getDisplayedSizeValueByUnit = (val, unit) => {
  return unit === USER_SIZE_UNIT_INCH ? mmToInch(val, true) : (Math.round(val * 1000) / 1000);
};

export const getCalcSizeValueByUnit = (inputVal, unit) => {
  const parseVal = parseFloat(inputVal) || 0;
  return unit === USER_SIZE_UNIT_INCH ? inchToMm(parseVal, true) : (Math.round(parseVal * 100) / 100);
};

export const getGroups = pages => {
  const groups = [];
  for (const pageId in pages) {
    const page = pages[pageId];
    for (const layoutId in page.layouts) {
      const layout = page.layouts[layoutId];
      for (const groupId in layout.groups) {
        const group = layout.groups[groupId];
        if (!groups.some(g => g.id === group.id)) {
          groups.push(group);
        }
      }
    }
    break;
  }
  return groups;
};

export const filterSelectedSectionsForMode = (mode, pages, shieldsSelection, sectionsSelection) => {
  switch (mode) {
    case INTERACTION_MODE.EDIT:
      const section = getFirstSelectedSection(sectionsSelection, pages);
      if (section) {
        return [section];
      }
      break;
    default: {
      break;
    }
  }

  return [];
};

export const isNextCellDisabled = (pagesGroups, shieldsSelection) => {
  const shieldsSelectionIds = Object.keys(shieldsSelection);

  if(shieldsSelectionIds.length === 1) {
    const [shieldsSelectionId] = shieldsSelectionIds;

    return pagesGroups.reduce((acc, group) => {
      if (acc) return acc;

      const shieldsIds = Object.keys(group.shields);
      if(shieldsIds.length === 1) {
        const [shieldId] = shieldsIds;
        acc = shieldId === shieldsSelectionId;
      }
      return acc;
    }, false)
  }

  return false;
};

// NOT USED
export const serializeSchema = schema => JSON.stringify(schema, null, '\t');

export const getShield = (layouts, shieldId) => {
  for (const layoutUid in layouts) {
    const {groups} = layouts[layoutUid];
    for (const groupUid in groups) {
      const {shields} = groups[groupUid];
      if(shields.hasOwnProperty(shieldId)) {
        return shields[shieldId];
      }
    }
  }
};

export const isWebComponentEnvironment = () => process.env.REACT_APP_TARGET === APP_ENVIRONMENT.WEB_COMPONENT;

export const isXcoreEnvironment = () => process.env.REACT_APP_TARGET === APP_ENVIRONMENT.XCORE;
export const isPrime2Environment = (environment) => environment === XCORE_ENVIRONMENT.PRIME2;
export const isMarkingSystemEnvironment = (environment) => environment === XCORE_ENVIRONMENT.MARKING_SYSTEM;

export const isClipxWebEnvironment = () => process.env.REACT_APP_TARGET === APP_ENVIRONMENT.CLIPX_WEB;

export const getCurrentEnvironment = () => process.env.REACT_APP_TARGET;

export const getElementByQuerySelector = (selector) => {
  if (isWebComponentEnvironment()) {
    return document.querySelector(MARKING_EDITOR_WEB_COMPONENT_ELEMENT).shadowRoot.querySelector(selector);
  } 
  return document.querySelector(selector);
};

export const getActiveElement = () => {
  if (isWebComponentEnvironment()) {
    return document.querySelector(MARKING_EDITOR_WEB_COMPONENT_ELEMENT).shadowRoot.activeElement;
  } 
  return document.activeElement;
}

export const getElementsByQuerySelectorAll = (selector) => {
  if (isWebComponentEnvironment()) {
    return document.querySelector(MARKING_EDITOR_WEB_COMPONENT_ELEMENT).shadowRoot.querySelectorAll(selector);
  } 
  return document.querySelectorAll(selector);
}

export const getElementByGetElementById = (id) => {
  if (isWebComponentEnvironment()) {
    return document.querySelector(MARKING_EDITOR_WEB_COMPONENT_ELEMENT).shadowRoot.getElementById(id);
  } 
  return document.getElementById(id);
};

export const getElementByElementFromPoint = (e) => {
  if (isWebComponentEnvironment()) {
    return document.querySelector(MARKING_EDITOR_WEB_COMPONENT_ELEMENT).shadowRoot.elementFromPoint(e.clientX, e.clientY);
  } 
  return document.elementFromPoint(e.clientX, e.clientY);
};